export default {"src":"/_next/static/media/leftArrow.0dc724ce.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};